module.exports = __webpack_public_path__ + "static/media/br-rs.7c346249.svg";